import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import api from '../../api';

@inject('commonStore', 'menuStore', 'cartStore')
@observer
class CouponDialog extends Component {
  /** 쿠폰 번호 변경 */
  handleChangeCouponID = e => {
    this.props.cartStore.setCouponId(e.target.value.trim());
  };

  /** 쿠폰 조회 버튼 클릭 */
  handleClickCouponSearch = async () => {
    const { t, commonStore, menuStore, cartStore } = this.props;
    if (!cartStore.couponDialog.couponID) {
      commonStore.setSnackbar(true, t('coupon.placeholder.number'));
      return;
    }

    // 조회한 쿠폰 데이터 초기화
    cartStore.setCouponData(undefined);

    // 같은 주문내에 이미 사용한 쿠폰인지 체크
    const foundCartMenu = cartStore.cartData.menus.find(
      menu => menu.couponData?.CouponID === cartStore.couponDialog.couponID,
    );
    if (foundCartMenu) {
      commonStore.setSnackbar(true, t('coupon.error.used'));
      return;
    }

    try {
      const response = await api.getCoupon(
        menuStore.storeData.companyId,
        menuStore.storeData.storeCode,
        cartStore.couponDialog.couponID,
        cartStore.couponDialog.itemCode,
      );
      const coupon = response.data;

      if (coupon.ErrorCode) {
        let errorMessage;
        switch (coupon.ErrorCode) {
          case 2:
            errorMessage = t('coupon.error.expired');
            break;
          case 3:
            errorMessage = t('coupon.error.used');
            break;
          default:
            errorMessage = t('order.error.couponUnavailable');
            break;
        }
        commonStore.setSnackbar(true, errorMessage);
        return;
      }

      // 조회한 쿠폰 데이터 세팅
      cartStore.setCouponData(coupon);
    } catch {
      commonStore.setSnackbar(true, t('coupon.error.searchFailed'));
    }
  };

  /** 쿠폰 사용 */
  handleClickUseCoupon = () => {
    const { cartStore } = this.props;

    cartStore.applyCouponToCartMenu();

    cartStore.setCouponDialog(false);
  };

  /** 쿠폰 모달 닫기 */
  handleDialogClose = () => {
    this.props.cartStore.setCouponDialog(false);
  };

  render() {
    const { t, cartStore } = this.props;
    if (cartStore.couponData?.CouponID) console.log(cartStore.couponData.CreateDate);
    return (
      <Dialog open={cartStore.couponDialog.isOpen} maxWidth="md">
        <DialogTitle>{t('order.title.couponUse')}</DialogTitle>
        <DialogContent>
          <Box display="flex" gap={1} mt={1}>
            <TextField
              value={cartStore.couponDialog.couponID}
              placeholder={t('coupon.placeholder.number')}
              variant="outlined"
              fullWidth
              inputProps={{ maxLength: 18 }}
              sx={{ height: 56 }}
              onChange={this.handleChangeCouponID}
            />
            <Button variant="contained" color="secondary" sx={{ height: 56 }} onClick={this.handleClickCouponSearch}>
              {t('common.button.search')}
            </Button>
          </Box>
          {cartStore.couponData?.CouponID && (
            <Grid container direction="row" gap={1} wrap="nowrap" className="coupon-catainer">
              <Grid item alignContent="center">
                <Box display="flex" alignItems="center" justifyContent="center" height="100%">
                  <ConfirmationNumberIcon />
                </Box>
              </Grid>
              <Grid item container direction="column" xs={12} sm>
                <Grid item>
                  <Typography variant="h6">{cartStore.couponData.CouponName}</Typography>
                </Grid>
                {(cartStore.couponData.CreateDate || cartStore.couponData.ExpireDate) && (
                  <Grid item>
                    <Typography variant="caption">
                      {t('coupon.label.period')}:
                      {cartStore.couponData.CreateDate && <span>{cartStore.couponData.CreateDate}</span>} ~{' '}
                      {cartStore.couponData.ExpireDate && <span>{cartStore.couponData.ExpireDate}</span>}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          {cartStore.couponData?.CouponID && (
            <Button variant="contained" size="large" onClick={this.handleClickUseCoupon}>
              {t('common.button.use')}
            </Button>
          )}
          <Button size="large" onClick={this.handleDialogClose}>
            {t('common.button.cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withTranslation()(withRouter(CouponDialog));
